'use strict';
module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/is-pure.js
// module id = 48
// module chunks = 0